export class Config {
  static client_id = "13bfbcf2-fa19-4922-a2c2-10f8d72c5c9d";
  static authority =
    "https://login.microsoftonline.com/79e8676f-cb3f-45a6-8782-11185326340e";
  static appScopes = ["api://13bfbcf2-fa19-4922-a2c2-10f8d72c5c9d/user_impersonation"];
  static bearerToken = process.env.REACT_APP_TOKEN;
  static chatCompletionUrl = process.env.REACT_APP_CHAT_COMPLETION_URL;
}

export const lernwerkFeURL =
  "https://lernwerk-int.exxeta.network/learningcontent/";
